import axios from 'axios'
import { logout } from '../api/userApi'
import PNotify from 'pnotify/dist/es/PNotify'

axios.interceptors.request.use(
    (config) => {
        const accessToken = localStorage.getItem('accessToken')
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`
        }
        return config
    },
    (error) => {
        PNotify.error({
            title: 'Server Error',
            text: `${error.response.status} - ${error.response.statusText}`
        })
        Promise.reject(error)
    }
)

axios.interceptors.response.use(
    (response) => {
        return response
    },
    async (error) => {
        console.log(error.response)
        PNotify.error({
            title: 'Server Error',
            text: `${error.response.status} - ${error.response.statusText}`
        })
        /*const originalRequest = error.config
        let refreshToken = localStorage.getItem('refreshToken')
        if (refreshToken && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true
            const res = await userApi.refreshToken()
            if (res.status === 200) {
                localStorage.setItem('accessToken', res.data.token)
                return axios(originalRequest)
            }
        }*/
        logout()
        return Promise.reject(error)
    }
)
